import { FC, PropsWithChildren } from 'react';
import { ShowTransactions, ShowTransactionsListCard } from './components';

interface IPendingTransactionsWrapperProps {
  transactionLength: number | undefined;
}

export const PendingTransactionsWrapper: FC<
  PropsWithChildren<IPendingTransactionsWrapperProps>
> = ({ transactionLength, children }) => {
  if (!transactionLength) {
    return <ShowTransactionsListCard />;
  }

  return (
    <div className="flex flex-col gap-y-4">
      <ShowTransactions />
      <div className="flex flex-col gap-y-1">{children}</div>
    </div>
  );
};
